import Login from "./pages/Login";
import Blogs from "./pages/Blogs";
import UsersPage from "./pages/Users";
import DashboardHome from "./pages/Dashboard";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import RecipesPage from "./pages/Recipes";
import AddRecipePage from "./pages/Recipes/AddRecipe";
import EditRecipePage from "./pages/Recipes/EditRecipe";
import HomeScreenPage from "./pages/HomeScreen";
import HealthScreenPage from "./pages/HealthScreen";

const routes = [
  {
    path: "/forgot-password",
    component: ForgotPassword,
    routeType: "public",
    isAuthPage: true,
    layout: "auth",
    title: "Forgot Password",
  },
  {
    path: "/reset-password",
    component: ResetPassword,
    routeType: "public",
    isAuthPage: true,
    layout: "auth",
    title: "Reset Password",
  },
  {
    path: "/login",
    component: Login,
    routeType: "public",
    isAuthPage: true,
    layout: "auth",
    title: "Login",
  },
  {
    path: "/blogs",
    component: Blogs,
    routeType: "public",
    isAuthPage: false,
    layout: "public",
    title: "Blogs",
  },
  {
    path: "/dashboard",
    component: DashboardHome,
    routeType: "private",
    roles: ["ADMIN"],
    layout: "dashboard",
    title: "Dashboard",
  },
  {
    path: "/dashboard/users",
    component: UsersPage,
    routeType: "private",
    layout: "dashboard",
    title: "Users",
  },
  {
    path: "/dashboard/recipes",
    component: RecipesPage,
    routeType: "private",
    layout: "dashboard",
    title: "Recipes",
  },
  {
    path: "/dashboard/recipes/new",
    component: AddRecipePage,
    routeType: "private",
    layout: "dashboard",
    title: "Add New Recipe",
  },
  {
    path: "/dashboard/recipes/edit/:id",
    component: EditRecipePage,
    routeType: "private",
    layout: "dashboard",
    title: "Edit Recipe",
  },
  {
    path: "/dashboard/home-screen",
    component: HomeScreenPage,
    routeType: "private",
    layout: "dashboard",
    title: "Home Screen",
  },
  {
    path: "/dashboard/health-screen",
    component: HealthScreenPage,
    routeType: "private",
    layout: "dashboard",
    title: "Health Screen",
  },
];

export default routes;
